export const WEB_MIN_WIDTH = 768
export const WIDE_MIN_WIDTH = 1200

export const WEB_QUERY = `(min-width: ${WEB_MIN_WIDTH}px)`
export const WIDE_QUERY = `(min-width: ${WIDE_MIN_WIDTH}px)`

export const media = {
  web: `@media ${WEB_QUERY}`,
  wide: `@media ${WIDE_QUERY}`,
}

export const isWebLayoutEnabled = () => true
